export const ContractTimespam = {
    PER_THREE_MONTH: 'PER_THREE_MONTH',
    PER_SIXTH_MONTH: 'PER_SIXTH_MONTH',
    PER_YEAR: 'PER_YEAR',
    PER_MONTH: 'PER_MONTH'
};

export const PlanDuration = {
    PER_MONTH: 'PER_MONTH',
    PER_YEAR: 'PER_YEAR',
    PER_SIXTH_MONTH: 'PER_SIXTH_MONTH',
    PER_THREE_MONTH: 'PER_THREE_MONTH'
};

export const FeatureType = {
    CORE_CRM: 'CORE_CRM',
    MULTIBOARD_SUPPORT: 'MULTIBOARD_SUPPORT',
    LIVE_TRACKING: 'LIVE_TRACKING',
    INACTIVITY_MONITORING: 'INACTIVITY_MONITORING',
    CALL_MANAGEMENT: 'CALL_MANAGEMENT'
};

export const PlanType = {
    CONTRACT_BASIS: 'CONTRACT_BASIS',
    USER_BASIS: 'USER_BASIS',
    FREE_TRIAL: 'FREE_TRIAL'
};

export const leadCaputureAddon = {
    YOUTUBE: 'YOUTUBE',
    WHATSAPP: 'WHATSAPP',
    INSTAGRAM: 'INSTAGRAM',
    AI_CALLING: 'AI_CALLING',
    PARTNER: 'PARTNER',
    WEBSITE: 'WEBSITE'
};